import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'
import createAppClient from './commons/createAppClient'

let host
if (location.hostname === 'localhost') {
  host = 'http://localhost:3200'
  // host = 'http://47.94.156.98:3300'
} else if (location.hostname === '127.0.0.1') {
  host = 'http://47.94.156.98:3300'
} else {
  host = location.origin
}

let scoketHost = 'http://47.93.158.22:3205'

Vue.use(new VueSocketIO({
  debug: ['http://localhost:3200', 'http://47.94.156.98:3300'].includes(host),
  connection: `${scoketHost}`,
  options: {
    autoConnect: false // 关闭自动连接
  }
}))
const app = createAppClient(host)
window.app = app
Vue.prototype.$app = app

export default app
